<template>
  <div>
    <Container class="navbar">
      <Aside class="navbar_content">
        <NavBar />
      </Aside>
      <Container class="main-container">
        <Header />
        <Main class="main">
          <Elements />
        </Main>
      </Container>
    </Container>
  </div>
</template>

<script>
import Header from "./Navigation/Header.vue";
import NavBar from "./Navigation/NavBar.vue";
import Elements from "./Routes/Elements.vue";
import { ElContainer as Container, ElAside as Aside, ElMain as Main } from "element-plus";

export default {
  name: "LayOut",
  components: {
    Header,
    Container,
    Aside,
    NavBar,
    Main,
    Elements,
  },
};
</script>

<style scoped>
.navbar {
  height: 100vh;
}
.navbar_content {
  width: 300px;
  background-color: #001f3f;
}
.main {
  background-color: #f5f7f8;
}
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
